module.exports = {"id":"210814","name":"Julián Velázquez","rating":"71","photo":"./data/images/photos/1/210814.png","club":{"name":"Cruz Azul","logo":"./data/images/clubs/CruzAzul.png"},"positions":["DC"],"photoFolderIndex":1}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/JulianVelazquez0.json
// module id = 2244
// module chunks = 0